"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionaryToList = void 0;
/**
 * Create a list from dictionary values
 * @public
 *
 * @param dictionary - The dictionary to be mapped
 *
 * @returns An array of the dictionary values
 *
 * @example
 * ```ts
 * const config: Dictionary<string> = {
 * key: 'value',
 * }
 * const result = dictionaryToList(config);
 * console.log(result);
 * // -> ['value']
 * ```
 */
function dictionaryToList(dictionary) {
    return Object.values(dictionary);
}
exports.dictionaryToList = dictionaryToList;
//# sourceMappingURL=dictionary-to-list.js.map